import { get, post, put, remove } from "../../utils/httpClient";

const viewService = () => {
  const prefixApi = "duedates/views";

  const getViews = async (boardId) => {
    return await get(`/${prefixApi}/board`, { boardId: boardId });
  };

  const getView = async (id) => {
    return await get(`/${prefixApi}/${id}`);
  };

  const deleteView = async (id) => {
    return await remove(`/${prefixApi}/${id}`);
  };

  const createView = async (json) => {
    return await post(`/${prefixApi}`, json);
  };

  const updateView = async (json) => {
    return await put(`/${prefixApi}`, json);
  };

  const updateViewOrder = async (json) => {
    return await put(`/${prefixApi}/order`, json);
  };

  const saveView = async (
    id,
    { filters, hiddenColumns, columnOrder, sorts }
  ) => {
    return await post(`/${prefixApi}/${id}/save`, {
      filters,
      hiddenColumns,
      columnOrder,
      sorts,
    });
  };

  return {
    getViews,
    getView,
    createView,
    deleteView,
    updateView,
    updateViewOrder,
    saveView,
  };
};

export default viewService;
